export type Theme = {
  type: "storellet" | "lubuds"

  // header
  logo: string

  // footer
  androidDownloadLink: string
  iosDownloadLink: string
  showFooterItems: boolean
  downloadAppName: string
  facebookLink: string
  instagramLink: string
  whatsappLink?: string
  isDarkFooter: boolean
}

const themes: Record<string, Theme> = {
  storellet: {
    type: "storellet",

    logo: "/logo.png",

    androidDownloadLink: "https://short.storellet.com/Vdh3EQ",
    iosDownloadLink: "https://short.storellet.com/VwLyI1",
    showFooterItems: true,
    downloadAppName: "Storellet",
    facebookLink: "https://www.facebook.com/storellet",
    instagramLink: "https://www.instagram.com/storellet",
    whatsappLink: "https://wa.me/+85254200508",
    isDarkFooter: false,
  },
  lubuds: {
    type: "lubuds",

    logo: "/lubuds_logo.png",

    androidDownloadLink: "https://apps.apple.com/hk/app/lubuds/id1180519207",
    iosDownloadLink:
      "https://play.google.com/store/apps/details?id=com.lubuds.app&hl=en_US",
    showFooterItems: false,
    downloadAppName: "Lubuds",
    facebookLink: "https://www.facebook.com/lubudsfnbgroup",
    instagramLink: "https://www.instagram.com/lubudsfnbgroup",
    isDarkFooter: true,
  },
}

export const currentTheme =
  themes[import.meta.env.VITE_APP_THEME] || themes.storellet
